var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DynamicFormRender',{attrs:{"formId":_vm.formId,"filters":_vm.filter}}),_c('DynamicFormRender',{attrs:{"formId":_vm.formId2,"filters":_vm.filter2}}),_c('hr'),_c('button',{staticClass:"btn btn-lg btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }